import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FullClientInterface, OrderSignedInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface ContinueTestSignUseCaseParams {
    client: FullClientInterface;
}

@Injectable()
export class ContinueTestSignUseCase
    implements UseCaseWithParam<ContinueTestSignUseCaseParams, Observable<Transaction<OrderSignedInterface>>>
{
    constructor(private testProvider: TestProvider) {}

    bind(params: ContinueTestSignUseCaseParams): Observable<Transaction<OrderSignedInterface>> {
        return this.testProvider.continue(params.client.encryptedCode).pipe(
            map((transaction) =>
                transaction.map(
                    (orderSigned) => Transaction.success(cloneDeep(orderSigned)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
